import { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

// import { useTranslation } from 'react-i18next';
import { TabPanel, a11yProps } from '../../../UI/MuiTab';
import Lokacije from '../../Lokacije';
import KorisniciPrograma from '../../KorisniciPrograma';
import KontaktiFirme from '../../KontaktiFirme';
import KlijentiAlati from '../../KlijentiAlati';
import KlijentiMasine from '../../KlijentiMasine';
import KlijentiProizvodi from '../../KlijentiProizvodi';

const TabsProvider = ({ idKlijenta }) => {
  //   const { t, i18n } = useTranslation();
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (idKlijenta > 0) {
      setValue(0);
    }
  }, [idKlijenta]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ width: '98%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            style={{ padding: '2px' }}
          >
            <Tab
              disabled={!(idKlijenta !== 0)}
              label="Lokacije"
              sx={{ textTransform: 'none' }}
              {...a11yProps(0)}
            />
            <Tab
              disabled={!(idKlijenta !== 0)}
              label="Kontakt"
              sx={{ textTransform: 'none' }}
              {...a11yProps(1)}
            />
            <Tab
              disabled={!(idKlijenta !== 0)}
              label="Korisnici programa"
              sx={{ textTransform: 'none' }}
              {...a11yProps(2)}
            />
            <Tab
              disabled={!(idKlijenta !== 0)}
              label="Alati"
              sx={{ textTransform: 'none' }}
              {...a11yProps(3)}
            />
            <Tab
              disabled={!(idKlijenta !== 0)}
              label="Mašine"
              sx={{ textTransform: 'none' }}
              {...a11yProps(4)}
            />
            <Tab
              disabled={!(idKlijenta !== 0)}
              label="Proizvodi"
              sx={{ textTransform: 'none' }}
              {...a11yProps(5)}
            />
          </Tabs>
        </Box>
      </Box>
      <TabPanel value={value} index={0}>
        {idKlijenta !== 0 && <Lokacije idKlijenta={idKlijenta} />}
      </TabPanel>
      <TabPanel value={value} index={1}>
        <KontaktiFirme idKlijenta={idKlijenta} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <KorisniciPrograma idKlijenta={idKlijenta} klijent="klijent" />
      </TabPanel>

      <TabPanel value={value} index={3}>
        <KlijentiAlati idKlijenta={idKlijenta} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <KlijentiMasine idKlijenta={idKlijenta} />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <KlijentiProizvodi idKlijenta={idKlijenta} />
      </TabPanel>
      {/* <TabPanel value={value} index={2}>
        <UtroseniDelovi idRn={idRn} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Troskovi idRn={idRn} />
      </TabPanel> */}
    </>
  );
};

export default TabsProvider;
